import { render, staticRenderFns } from "./Optimism.vue?vue&type=template&id=bedcca82&"
import script from "./Optimism.vue?vue&type=script&lang=js&"
export * from "./Optimism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports